import Image from 'next/image';
import Link from 'next/link';

import { formatDate } from '@/utils/date-formatter';

import defaultImage from './images/defaultImage.png';

export type ShandsPost = {
  id: number;
  title: string;
  date: string;
  imageUrl: string | null;
  category?: string;
};

type Props = {
  posts: ShandsPost[];
  logEvent?: () => void;
};

const Component: React.FC<Props> = ({ posts, logEvent }) => {
  return (
    <div className="grid grid-cols-2 gap-x-4 gap-y-5 md:grid-cols-4 md:gap-x-6 md:gap-y-9">
      {posts.map(post => (
        <Link
          onClick={logEvent}
          className="flex flex-col"
          prefetch={false}
          key={post.id}
          href={`/archives/${post.id}`}
        >
          <div className="w-full">
            <div className="aspect-video rounded-lg border border-gray-300">
              <div className="relative h-full w-full md:rounded-lg">
                <Image
                  className="rounded-lg object-cover"
                  src={post.imageUrl ?? defaultImage.src}
                  alt=""
                  fill
                />
              </div>
            </div>
          </div>
          <div className="my-1 font-bold">{post.title}</div>
          <div className="flex justify-between text-sm text-zinc-400">
            <div>{formatDate(post.date)}</div>
            <div>{post.category}</div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default Component;
